import type { CameraPose } from '../three/bucket/BucketSceneController'

export const motionTokens = {
  fast: 0.18,
  standard: 0.42,
  cinematic: 0.9,
  reducedOpacity: 0.1,
  easeOut: 'power3.out',
  spring: { type: 'spring', stiffness: 480, damping: 30 },
} as const

export type TreatShowCameraLabel =
  | 'portal'
  | 'matchCut'
  | 'bucket'
  | 'guide'

export const treatShowCameraPoses: Record<
  TreatShowCameraLabel,
  CameraPose
> = {
  portal: { x: 0, y: 0.32, z: 6.2, fov: 44 },
  matchCut: { x: 0, y: 0.18, z: 5.35, fov: 40 },
  bucket: { x: 0, y: 0.05, z: 4.55, fov: 36 },
  guide: { x: -0.32, y: 0.14, z: 5.05, fov: 38 },
}
